import React, { useState, useEffect, useRef } from "react";
import Ink from "react-ink";
import { useNavigate } from "react-router-dom";

const RestaurantSearch = ({ searchFunction }) => {
    const [restaurant, setRestaurant] = useState("");
    const searchInput = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (searchInput.current) {
            searchInput.current.focus();
        }
    }, []);

    const handleInputChange = (e) => {
        setRestaurant(e.target.value);
        searchFunction(e.target.value);
    };

    return (
        <React.Fragment>
            <div className="col-12 p-0">
                <div className="block m-0">
                    <div className="block-content p-0">
                        <div className="input-group search-box">
                            <div className="input-group-prepend">
                                <button
                                    type="button"
                                    className="btn search-navs-btns"
                                    style={{ position: "relative" }}
                                    onClick={() => navigate(-1)}
                                >
                                    <i className="si si-arrow-left" />
                                    <Ink duration="500" />
                                </button>
                            </div>
                            <input
                                type="text"
                                className="form-control search-input"
                                placeholder={localStorage.getItem("restaurantSearchPlaceholder")}
                                value={restaurant}
                                onChange={handleInputChange}
                                ref={searchInput}
                            />
                            <div className="input-group-append">
                                <button type="submit" className="btn search-navs-btns" style={{ position: "relative" }}>
                                    <i className="si si-magnifier" />
                                    <Ink duration="500" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default RestaurantSearch;
